<template>
  <grid-row>
    <grid-column>
      <form-field-currency
        label="Amount"
        v-model="form.amount"
        :validation-errors="validationErrors.amount"
      ></form-field-currency>

      <form-field-select
        label="Type"
        v-model="form.type"
        :validation-errors="validationErrors.type"
      >
        <option
          v-for="option in offerTypes"
          :key="option.value"
          :value="option.value"
        >{{ option.label }}</option>
      </form-field-select>

      <form-field-select
        label="Made By"
        v-model="form.made_by"
        :validation-errors="validationErrors.made_by"
      >
        <option :value="null">Seller</option>
        <option
          v-for="user in activeUsers"
          :key="user.id"
          :value="user.id"
        >{{ user.full_name }}</option>
      </form-field-select>
    </grid-column>

    <grid-column>
      <form-field-date-picker
        label="Offer Date"
        v-model="form.date"
        :validation-errors="validationErrors.date"
        is-inline
      ></form-field-date-picker>
    </grid-column>
  </grid-row>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";
  import dates from "../services/dates";

  export default {
    name: "BuyingOfferForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          record_id: '',
          type: ENUMS.BuyingOfferTypeEnum.Verbal.value,
          date: dates.getNowISO(),
          amount: '',
          made_by: this.$store.getters.activeUsers[0].id,
          status: 1,
        },
      }
    },
    computed: {
      offerTypes() {
        return ENUMS.BuyingOfferTypeEnum;
      },
      activeUsers() {
        return this.$store.getters.activeUsers;
      },
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the create
      const isUpdate = this.formData && this.formData.id

      if(isUpdate) {
        this.form = this.$utils.clone(this.formData)

        // this sets the timezone properly for datepicker
        this.form.date = this.form.date.split('T')[0]
        this.form.date = dates.addUserTimezone(this.form.date).toISO()
      } else {
        this.form = this.$utils.clone({...this.defaultForm, ...this.formData})
      }
    },
    methods: {
      update() {
        if(this.form.date) {
          this.form.date = new Date(this.form.date).toISOString().split('T')[0];
        }

        return this.$api.buyingOffers.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'BuyingOffer was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        if(this.form.date) {
          this.form.date = new Date(this.form.date).toISOString().split('T')[0];
        }

        return this.$api.buyingOffers.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'BuyingOffer was created',
              type: 'is-success'
            });

            return res;
          })
        },
      delete() {
        return this.$api.buyingOffers.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'BuyingOffer was archived',
              type: 'is-success'
            });

            return res;
          });
      },
      restore() {
        return this.$api.buyingOffers.restore(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'BuyingOffer was restored',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
